import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setBloodTypeOptions } from '../store/options.actions'

export function* getBloodTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const bloodTypeResponse: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getBloodTypeOptions,
    ])
    const { entity } = bloodTypeResponse
    yield put(setBloodTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBloodTypeOptions() error: ${e}`))
  }
}

export function* getBloodTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBloodTypeOptions)
}
